var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { DataStub } from '@tencent/data-schema-core';
import ExprInputCompletionProvider from '../../comps/ExprInput/ExprInputCompletionProvider';
import { INJECT_SIMPLE_FLOW_EDITOR, INJECT_SIMPLE_FLOW_STEP_LIST } from './consts';
import { getTitleWithParentheses } from "../../../lib/utils/string";
import { INJECT_UICORE_BUS } from "../../../lib/utils/consts";
const stateDescription = '- 如果步骤配置了“传递输出...给后续步骤”\n- 或者步骤执行了 `flowState.xxx = "hello";`\n\n那么，后续步骤可通过 `flowState.xxx` 去引用数据';
let StepExprInputContextProvider = class StepExprInputContextProvider extends Vue {
  getDataStub() {
    const flowStateFields = this.stepList.steps.slice(0, this.index).map((step, index) => {
      var _atom$returnValue, _this$uc, _this$uc2;
      const id = step.backfill;
      if (!id) return null;
      const atom = this.flowEditor.atoms[step.type];
      const baseSchema = atom === null || atom === void 0 || (_atom$returnValue = atom.returnValue) === null || _atom$returnValue === void 0 ? void 0 : _atom$returnValue.call(atom, step.params, {
        uc: this.uc,
        designer: (_this$uc = this.uc) === null || _this$uc === void 0 ? void 0 : _this$uc.designer,
        renderer: (_this$uc2 = this.uc) === null || _this$uc2 === void 0 || (_this$uc2 = _this$uc2.designer) === null || _this$uc2 === void 0 ? void 0 : _this$uc2.renderer
      });
      return {
        type: 'any',
        ...baseSchema,
        id,
        description: `**(数据来自第 ${index + 1} 步）**\n\n${(baseSchema === null || baseSchema === void 0 ? void 0 : baseSchema.description) || ''}`
      };
    }).filter(x => !!x);
    const args = this.flowEditor.argumentsSchemas;
    const $event = {
      type: 'any',
      ...(args === null || args === void 0 ? void 0 : args[0]),
      id: '$event',
      title: '事件参数'
    };
    const argsDesc = ['一个数组，内含包括 `$events` 在内的全部事件参数\n'];
    if (Array.isArray(args)) {
      argsDesc.push(`共有 ${args.length} 个元素\n`);
      args.forEach((arg, idx) => {
        let title = getTitleWithParentheses(arg.id, arg.description);
        if (title) title = `**${title}** - `;
        argsDesc.push(`${idx}. ${title}${arg.description}`);
      });
    }
    const schema = {
      type: 'object',
      fields: [
      // @ts-ignore 其实现在是支持出现 null 自动剔除的
      !!flowStateFields.length && {
        id: 'flowState',
        type: 'object',
        title: '事件流程临时变量',
        description: stateDescription,
        fields: flowStateFields
      }, $event, {
        id: 'flow',
        title: '事件流程上下文',
        type: 'object',
        fields: [$event, {
          id: 'args',
          type: 'array',
          title: '额外事件参数',
          description: argsDesc.join('\n')
        }, {
          id: 'state',
          type: 'object',
          title: '事件流程临时变量',
          description: stateDescription,
          fields: flowStateFields
        }],
        methods: [{
          id: 'abort',
          title: '阻断流程',
          description: '调用此方法后，后续的步骤将不会执行！\n\n但是，当前步骤仍然会执行完'
        }]
      }]
    };
    const dataStub = new DataStub({
      schema
    });
    return dataStub;
  }
  render() {
    const h = arguments[0];
    return h(ExprInputCompletionProvider, {
      "attrs": {
        "dataStub": this.getDataStub
      }
    }, [this.$slots.default]);
  }
};
__decorate([Inject(INJECT_SIMPLE_FLOW_STEP_LIST)], StepExprInputContextProvider.prototype, "stepList", void 0);
__decorate([Inject(INJECT_SIMPLE_FLOW_EDITOR)], StepExprInputContextProvider.prototype, "flowEditor", void 0);
__decorate([Inject({
  from: INJECT_UICORE_BUS,
  default: null
})], StepExprInputContextProvider.prototype, "uc", void 0);
__decorate([Prop(Number)], StepExprInputContextProvider.prototype, "index", void 0);
StepExprInputContextProvider = __decorate([Component({
  name: 'StepExprInputContextProvider'
})], StepExprInputContextProvider);
export default StepExprInputContextProvider;
//# sourceMappingURL=StepExprInputContextProvider.js.map
